module.exports = __webpack_public_path__ + "834c5a994f8b082cf3526dfb84e0df20.jpg";